import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
} from 'react-admin'


export const SistemaInterconectadoShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="code" />
        </SimpleShowLayout>
    </Show>
);
